import { ReactElement } from 'react';
import { getSchema } from '@localstack/services';
import Firehose from 'aws-sdk/clients/firehose';

import { MagicForm } from '../../magic/MagicForm';

export interface FirehoseStreamCreateFormProps {
  onCreate: (data: Firehose.CreateDeliveryStreamInput) => unknown;

  loading?: boolean;
  formId?: string;
}

export const FirehoseStreamCreateForm = ({
  loading,
  formId,
  onCreate,
}: FirehoseStreamCreateFormProps): ReactElement => (
  <MagicForm
    schema={getSchema('Firehose')}
    loading={loading}
    entry="CreateDeliveryStreamInput"
    formId={formId}
    fieldConditions={{
      '^StreamARN$': false,
    }}
    onSubmit={onCreate}
  />
);
